import styles from './PersonCard.module.css';
import globalButtonStyles from '../../styles/ButtonGradient.module.css';
import {
  GiBasketballBall,
  GiAmericanFootballBall,
  GiSoccerBall,
  GiVolleyballBall,
  GiTennisBall,
  GiBaseballGlove
} from 'react-icons/gi';
import { FiUserCheck } from 'react-icons/fi';

const sportIcons = {
  basketball: <GiBasketballBall />,
  football: <GiAmericanFootballBall />,
  soccer: <GiSoccerBall />,
  volleyball: <GiVolleyballBall />,
  tennis: <GiTennisBall />,
  baseball: <GiBaseballGlove />,
  coach: <FiUserCheck />
};

const PersonCard = ({
  name = 'Unnamed',
  image,
  role = 'athlete',
  sport = '',
  onApprove,
  onReject,
  isPendingApproval = false
}) => {
  const renderRightElement = () => {
    if (role === 'coach' && isPendingApproval) {
      return (
        <div className={styles.buttonGroup}>
          <button
            className={`${globalButtonStyles.button} ${styles.approveBtn}`}
            onClick={onApprove}
          >
            Approve
          </button>
          <button
            className={`${globalButtonStyles.button} ${styles.rejectBtn}`}
            onClick={onReject}
          >
            Decline
          </button>
        </div>
      );
    }

    const iconKey = role === 'athlete' ? sport : 'coach';
    const icon = sportIcons[iconKey] || <FiUserCheck />;

    return <div className={styles.icon}>{icon}</div>;
  };

  const profileImage = image || '/images/avatar-boy-svgrepo-com.svg';

  return (
    <div className={styles.card}>
      <img
        src={profileImage}
        alt={name}
        className={styles.profilePic}
        onError={(e) => { e.target.src = '/images/avatar-boy-svgrepo-com.svg'; }}
      />
      <div className={styles.name}>{name}</div>
      {renderRightElement()}
    </div>
  );
};

export default PersonCard;